import { FC, useState } from "react";
import { useMutation } from "@apollo/client";
import { holdKavaDecision } from "graphql/mutations/holdOffers";

interface HoldOfferActionsProps {
  offer: any;
  refresh?: () => void;
}

const HoldOfferActions: FC<HoldOfferActionsProps> = ({ offer, refresh }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const holdParticipant = offer?.hold_kava_participant;
  const decision = holdParticipant?.decision;
  const hasDecision = holdParticipant && decision;

  const [makeDecision] = useMutation(holdKavaDecision, {
    onCompleted: () => {
      setIsProcessing(false);
      if (refresh) refresh();
    },
    onError: (error) => {
      setIsProcessing(false);
      alert(`Error: ${error.message}`);
    },
  });

  const handleAccept = async () => {
    if (isProcessing || hasDecision) return;
    setIsProcessing(true);

    await makeDecision({
      variables: {
        input: {
          offer_id: parseInt(offer.offer_detail.offersoffer_id),
          decision: "ACCEPT",
          published_by: offer.offer_from || "PLACEIT",
        },
      },
    });
  };

  const handleDecline = async () => {
    if (isProcessing || hasDecision) return;
    setIsProcessing(true);

    await makeDecision({
      variables: {
        input: {
          offer_id: parseInt(offer.offer_detail.offersoffer_id),
          decision: "DECLINE",
          published_by: offer.offer_from || "PLACEIT",
        },
      },
    });
  };

  if (hasDecision) {
    return null;
  }

  return (
    <div className="flex gap-2 justify-center">
      <button
        onClick={handleAccept}
        disabled={isProcessing}
        className="px-3 py-1.5 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isProcessing ? "..." : "Accept"}
      </button>
      <button
        onClick={handleDecline}
        disabled={isProcessing}
        className="px-3 py-1.5 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isProcessing ? "..." : "Decline"}
      </button>
    </div>
  );
};

export default HoldOfferActions;
